import React from 'react';
import { IonIcon, IonButton } from '@ionic/react';
import { close } from 'ionicons/icons';
import Modal from './Modal';
import './AETNAInformationModal.css';

interface AETNAInformationModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback fired when modal should close */
  onClose: () => void;
  /** Additional CSS class name */
  className?: string;
}

function AETNAInformationModal({
  isOpen,
  onClose,
  className = '',
}: AETNAInformationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={className}
    >
      <div className="aetna-information-modal-content">
        <IonButton onClick={onClose} className="aetna-information-modal-close-button">
          <IonIcon icon={close} />
        </IonButton>
        <p className="aetna-information-modal-heading">
          What This Does:
        </p>
        <p className="aetna-information-modal-text">
        This setting lets you automatically send data to AETNA | Allina Health about LoreBot safety messages.
        </p>
        <p className="aetna-information-modal-heading">
          Why This Matters!
        </p>
        <p className="aetna-information-modal-text">
        LoreBot contains safety features. Chats with LoreBot about self-harm or harm to others will result in a message like, <strong>"If you are having an emergency, please immediately call 911, call or text 988, or go to a hospital!"</strong>        </p>
      </div>
    </Modal>
  );
}

export default AETNAInformationModal;

